import { render, staticRenderFns } from "./BookList.vue?vue&type=template&id=14596498&scoped=true&"
import script from "./BookList.vue?vue&type=script&lang=ts&"
export * from "./BookList.vue?vue&type=script&lang=ts&"
import style1 from "./BookList.vue?vue&type=style&index=1&id=14596498&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14596498",
  null
  
)

export default component.exports